import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";

@Directive({
	selector: "[appStepLazyRendering]",
	standalone: false
})
export class StepLazyRenderingDirective {
	private readonly FIRST_CONTAINER_VIEW = 0;
	private showStep = false;

	constructor(
		private templateRef: TemplateRef<unknown>,
		private viewContainer: ViewContainerRef
	) {}

	@Input() set appStepLazyRendering(showStep: boolean) {
		this.showStep = showStep;
		this.updateView();
	}

	@Input()
	appStepLazyRenderingMantainViewAfterCreation = false;

	private updateView(): void {
		if (
			this.appStepLazyRenderingMantainViewAfterCreation &&
			this.viewContainer.get(this.FIRST_CONTAINER_VIEW)
		) {
			return;
		}

		if (this.showStep) {
			this.viewContainer.createEmbeddedView(this.templateRef);
			return;
		}
		this.viewContainer.clear();
	}
}
